import React from "react";
import { Carousel, Typography, Card } from "antd";
import ProductCard from "./ProductCard";

const ShopByCategory = ({ isMobile, categories }) => {
  return (
    <div className="md:py-10 py-5">
      <div className="flex justify-center">
        <p
          level={2}
          className="text-center mb-5 md:mb-8 uppercase border-b border-[#d7d4d4] text-xl md:text-2xl font-semibold leading-[28px] md:leading-[34px]"
        >
          Shop By Category
        </p>
      </div>
      <Carousel
        dots={false}
        arrows
        slidesToShow={4}
        draggable={true}
        responsive={[
          { breakpoint: 1024, settings: { slidesToShow: 3 } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
        ]}
      >
        {categories?.map((category, index) => (
          <div key={index} className="px-2 cursor-pointer">
            <ProductCard
              height={isMobile ? 350 : 500}
              name={<p className="font-semibold">{category.name}</p>}
              image={category.image}
              navigateLink={category.link}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default ShopByCategory;
